var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/ExplorePanel.tsx",
  _this = this;
import React, { useRef, useEffect } from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Link } from '@wds/link';
import { IconArrowBox } from '@wds/icons';
import { useHeaderTheme } from '../../theme';
import SolutionsIcon from './assets/Solutions';
import AudienceIcon from './assets/Audience';
import useStyles from './useStyles';
var ExplorePanel = function ExplorePanel(_ref) {
  var show = _ref.show,
    onToggle = _ref.onToggle;
  var ref = useRef(null);
  var theme = useHeaderTheme();
  var _useStyles = useStyles({
      theme: theme
    }),
    panel = _useStyles.panel,
    title = _useStyles.title,
    leftBox = _useStyles.leftBox,
    rightBox = _useStyles.rightBox;
  useEffect(function () {
    if (show) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [show]);
  if (!show) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    role: "menu",
    tabIndex: -1,
    ref: ref,
    onBlur: function onBlur(e) {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        onToggle();
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    className: panel,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    pt: 6,
    pr: 2,
    pb: 4,
    pl: 6,
    className: leftBox,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mb: 4,
    alignItems: "center",
    className: title,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "inline",
    mr: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(AudienceIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    weight: "medium",
    variant: "body",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 13
    }
  }, "Audience")), /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }, "Survey people who live, work, and do what matters to you. Reach audiences in 130+ countries and get responses quickly."), /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    weight: "medium",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/collect/audience/calculator/preview?ut_source=header&ut_source3=buy_targeted_responses",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 15
    }
  }, "Buy targeted responses")))), /*#__PURE__*/React.createElement(Box, {
    flexItemGrow: true,
    pt: 6,
    pr: 5,
    pb: 4,
    pl: 6,
    className: rightBox,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: title,
    display: "flex",
    mb: 4,
    alignItems: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SolutionsIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    weight: "medium",
    variant: "body",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 13
    }
  }, "Brand and market research")), /*#__PURE__*/React.createElement(Box, {
    mb: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 13
    }
  }, "Discover expert-designed solutions to gather feedback on your ideas, products, and business. Get valuable insights delivered in days.")), /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/market-research/solutions/brand-tracker/?ut_source=header&ut_source3=trackers",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 15
    }
  }, "Brand tracking"))), /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/market-research/solutions/ad-creative-analysis/?ut_source=header&ut_source3=ad_creative_analysis",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 15
    }
  }, "Ad testing"))), /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/market-research/solutions/idea-screening/?ut_source=header&ut_source3=idea_screener",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 15
    }
  }, "Idea screening"))), /*#__PURE__*/React.createElement(Box, {
    mb: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/market-research/solutions/price-optimization/?ut_source=header&ut_source3=van_west",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 15
    }
  }, "Price optimization"))), /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "link",
    weight: "medium",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Link, {
    underline: false,
    href: "https://www.surveymonkey.com/market-research/solutions/get-started/?ut_source=header",
    target: "_blank",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 13
    }
  }, "Explore more solutions", /*#__PURE__*/React.createElement(Box, {
    display: "inline",
    ml: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(IconArrowBox, {
    title: "link icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 17
    }
  })))))));
};
export default ExplorePanel;
//# sourceMappingURL=ExplorePanel.js.map